import MultipleColumnsDataListAdmin from './MultipleColumnsDataListAdmin'
import MultipleColumnsDataListEdit from './MultipleColumnsDataListEdit'
import MultipleColumnsDataListView from './MultipleColumnsDataListView'

const useMultipleColumnsDataList = () => {
  const viewSwitcher = (
    admin,
    editMode,
    item,
    index,
    fieldIndex,
    updateFieldLabel,
    numberOfColumn,
    toggleIsHidden,
    label,
    updateDataType
  ) => {
    if (!item) {
      return ''
    }
    if (admin) {
      return (
        <MultipleColumnsDataListAdmin
          key={item.fieldId}
          data={item}
          cardIndex={index}
          fieldIndex={fieldIndex}
          updateFieldLabel={updateFieldLabel}
          numberOfColumn={numberOfColumn}
          toggleIsHidden={toggleIsHidden}
          updateDataType={updateDataType}
        />
      )
    }

    if (editMode) {
      return (
        <MultipleColumnsDataListEdit
          key={item.fieldId}
          data={item}
          cardIndex={index}
          fieldIndex={fieldIndex}
          numberOfColumn={numberOfColumn}
          cardLabel={label}
        />
      )
    }

    return (
      <MultipleColumnsDataListView
        key={item.fieldId}
        data={item}
        cardIndex={index}
        fieldIndex={fieldIndex}
        updateFieldLabel={updateFieldLabel}
        numberOfColumn={numberOfColumn}
        toggleIsHidden={toggleIsHidden}
      />
    )
  }

  return { viewSwitcher }
}

export default useMultipleColumnsDataList
